import Link from 'next/link';
import ShowMoreList from './ShowMoreList';
import { alertPath } from 'utils/alert-url';
import { displayDate } from 'utils/directory';
import styles from 'styles/modules/BrokerDirectory.module.scss';

const OPEN_STORIES = 10;

// "Newspage stories on …" for topic and town pages: headline, date and link only.
export default function DirectoryStories({ stories, label }) {
    if (!stories?.length) return null;
    return (
        <>
            <h2 className={styles.sectionTitle}>Newspage stories on {label}</h2>
            <ShowMoreList
                id="directory-stories"
                items={stories}
                open={OPEN_STORIES}
                itemKey={(story) => story.slug}
                nouns={['story', 'stories']}
                listClassName={styles.stories}
                hiddenClassName={styles.folded}
                buttonClassName={styles.showMore}
                renderItem={(story) => (
                    <>
                        <Link href={alertPath(story.slug)}>
                            <a>{story.headline}</a>
                        </Link>
                        {displayDate(story.publishedAt) && (
                            <time dateTime={story.publishedAt}>
                                {displayDate(story.publishedAt)}
                            </time>
                        )}
                    </>
                )}
            />
        </>
    );
}
